import { request as enablementRequest } from './enablement';
import { request as consultingRequest } from './consulting';

// 製品ごとの資料請求ページ（/documents/:product）の単一情報源。
// お問い合わせ（/contact）とは別のページにする（2026-10-17 代表指示）。
// documents の id は src/lib/leadApi.js の DOCUMENTS と lead-api の資料定義に一致させる。
// 資料請求のページには目次を載せない（2026-10-17 代表指示）。表紙の画像とフォームだけを置く。

// 資料請求のフォームには「相談したい」の選択肢を置かない（相談はお問い合わせへ）
const withoutConsult = (list) => list.filter((x) => x !== 'まずは相談したい');

export const DOCUMENT_PAGES = {
  trooper: {
    slug: 'trooper',
    accent: 'blue',
    product: 'Trooper',
    kind: 'AIエージェント製品',
    en: ['TROOPER', 'DOCUMENTS'],
    lead: [
      ['Trooper の資料をご用意しています。'],
      ['フォームを送信すると、その場でダウンロードできます。'],
    ],
    documents: ['trooper', 'trooper-sales'],
    defaultDocuments: ['trooper', 'trooper-sales'],
    interests: [
      'トライアル（1〜2週間・有償）',
      'Trooper Workhub',
      'Trooper for Sales',
      'Trooper for Recruit',
      'Trooper for HR',
      'セキュリティ・データの置き場所',
    ],
    covers: [
      { src: '/img/documents/trooper-cover.jpg', alt: 'Trooperのご紹介 の表紙' },
      { src: '/img/documents/trooper-sales-cover.jpg', alt: 'Trooper for Salesのご紹介 の表紙' },
    ],
    // 製品ページは独立した静的ページ（public/trooper/）なので、ページの読み込み直しで移る
    back: { href: '/trooper/', label: 'Trooper のページへ戻る' },
  },
  enablement: {
    slug: 'enablement',
    accent: 'blue',
    product: 'AI内製化支援',
    kind: '内製化支援',
    en: ['ENABLEMENT', 'DOCUMENTS'],
    lead: [
      ['AI内製化支援の資料をご用意しています。'],
      ['フォームを送信すると、その場でダウンロードできます。'],
    ],
    documents: ['enablement'],
    defaultDocuments: ['enablement'],
    interests: withoutConsult(enablementRequest.interests),
    covers: [{ src: '/img/documents/enablement-cover.jpg', alt: 'AI内製化支援のご紹介 の表紙' }],
    back: { to: '/enablement', label: '内製化支援のページへ戻る' },
  },
  consulting: {
    slug: 'consulting',
    accent: 'orange',
    product: 'AIコンサルティング・開発',
    kind: 'AIコンサルティング・開発',
    en: ['CONSULTING', 'DOCUMENTS'],
    lead: [
      ['AIコンサルティング・開発の資料をご用意しています。'],
      ['フォームを送信すると、その場でダウンロードできます。'],
    ],
    documents: ['consulting'],
    defaultDocuments: ['consulting'],
    interests: withoutConsult(consultingRequest.interests),
    covers: [{ src: '/img/documents/consulting-cover.jpg', alt: 'AIコンサルティング・開発のご紹介 の表紙' }],
    back: { to: '/cases', label: 'AIコンサルティング・開発のページへ戻る' },
  },
};

export const DOCUMENT_PAGE_ORDER = ['trooper', 'enablement', 'consulting'];

export const documentPath = (slug) => `/documents/${slug}`;

// 古いリンク（/contact?type=doc&docs=...）を、製品ごとの資料請求ページへ読み替える
export const documentPathFromIds = (ids = []) => {
  if (ids.some((id) => id === 'trooper' || id === 'trooper-sales')) return documentPath('trooper');
  if (ids.includes('enablement')) return documentPath('enablement');
  if (ids.includes('consulting')) return documentPath('consulting');
  return '/documents';
};
